import { useMutation, useQuery } from "@tanstack/react-query";
import Api from "../../features/one-query/services/ApiServices";

interface CrateShareURLData {
  shareType: number;
  shareId: string;
}

// Create share url.
const createShareUrl = async (data: CrateShareURLData) => {
  const response = await Api.post("/Share/CreateShareEntry", data);
  return response.data;
};

const useCreateShareUrl = () => {
  return useMutation({
    mutationKey: ["createShareUrl"],
    mutationFn: (data: CrateShareURLData) => createShareUrl(data),
  });
};

//===================================================================

// Get sharing workflow data.
const getSharingWorkflowData = async (runId: string) => {
  const response = await Api.get(
    `/Workflow/GetWorkflowRunShareData?runId=${runId}`
  );
  return response.data;
};

const useGetSharingWorkflowData = (runId: string) => {
  return useQuery({
    queryKey: ["getSharingWorkflowData"],
    queryFn: () => getSharingWorkflowData(runId),
    enabled: !!runId,
    refetchOnWindowFocus: false,
  });
};

export { useCreateShareUrl, useGetSharingWorkflowData };
